module.exports = __webpack_public_path__ + "img/1_02.df2115a1.jpg";